"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _InventoryWindow = _interopRequireDefault(require("../items/InventoryWindow/InventoryWindow"));

var _OptionsWindow = _interopRequireDefault(require("../other/OptionsWindow/OptionsWindow"));

var _item = _interopRequireWildcard(require("../../../mocks/item"));

var _GroupsWindow = _interopRequireDefault(require("../other/GroupsWindow/GroupsWindow"));

var _guild = _interopRequireDefault(require("../../../mocks/guild"));

var _PromptWindow = _interopRequireDefault(require("../other/PromptWindow/PromptWindow"));

var _QuestDetailsWindow = _interopRequireDefault(require("../other/QuestDetailsWindow/QuestDetailsWindow"));

var _QuestListWindow = _interopRequireDefault(require("../other/QuestListWindow/QuestListWindow"));

var _items = require("../items");

var _CraftingWindow = _interopRequireDefault(require("../items/CraftingWindow/CraftingWindow"));

var _NpcWindow = _interopRequireDefault(require("../other/NpcWindow/NpcWindow"));

var _BillingWindow = _interopRequireDefault(require("../items/BillingWindow/BillingWindow"));

var _TradeWindow = _interopRequireDefault(require("../items/TradeWindow/TradeWindow"));

var _CharacterStatsWindow = _interopRequireDefault(require("../other/CharacterStatsWindow/CharacterStatsWindow"));

var _character = _interopRequireDefault(require("../../../mocks/character"));

var _CommandEditWindow = _interopRequireDefault(require("../other/CommandEditWindow/CommandEditWindow"));

var _HiringWindow = _interopRequireDefault(require("../other/HiringWindow/HiringWindow"));

var _InputMoneyWindow = _interopRequireDefault(require("../other/InputMoneyWindow/InputMoneyWindow"));

var _InputTextWindow = _interopRequireDefault(require("../other/InputTextWindow/InputTextWindow"));

var _PartyFindWindow = _interopRequireDefault(require("../other/PartyFindWindow/PartyFindWindow"));

var _PositionMemorizeWindow = _interopRequireDefault(require("../other/PositionMemorizeWindow/PositionMemorizeWindow"));

var _SkillsWindow = _interopRequireDefault(require("../other/SkillsWindow/SkillsWindow"));

var _skill = _interopRequireWildcard(require("../../../mocks/skill"));

var _skillCombo = _interopRequireDefault(require("../../../mocks/skillCombo"));

var _nation = _interopRequireDefault(require("../../../mocks/nation"));

var _MainBorderedWindow = _interopRequireDefault(require("../common/MainBorderedWindow2/MainBorderedWindow2"));

var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mockedManagedWindows = [{
  posX: 1000,
  posY: 300,
  component: /*#__PURE__*/_react.default.createElement(_InventoryWindow.default, {
    equipment: {
      equipmentSlots: []
    },
    itemPool: {
      items: [_item.default, _item.item2],
      sizeX: 7,
      sizeY: 6
    }
  })
}, {
  posX: 100,
  posY: 20,
  component: /*#__PURE__*/_react.default.createElement(_GroupsWindow.default, {
    guild: _guild.default,
    guildMemberType: "MASTER",
    nation: _nation.default,
    friends: []
  })
}, {
  component: /*#__PURE__*/_react.default.createElement(_QuestDetailsWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_QuestListWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_PromptWindow.default, {
    onSubmit: function onSubmit() {
      /* no-op */
    }
  }, "no-op")
}, {
  component: /*#__PURE__*/_react.default.createElement(_items.BankWindow, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_CraftingWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_items.VendorWindow, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_NpcWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_BillingWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_items.LootWindow, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_TradeWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_CommandEditWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_HiringWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_InputMoneyWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_InputTextWindow.default, {
    title: "Whats your name?"
  })
}, // { component: <MapWindow /> }, // non dragable
{
  component: /*#__PURE__*/_react.default.createElement(_OptionsWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_PartyFindWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_PositionMemorizeWindow.default, null)
}, {
  component: /*#__PURE__*/_react.default.createElement(_SkillsWindow.default, {
    classSkills: [_skill.default, _skill.unlearnedClassSkill],
    craftingSkills: [_skill.craftingSkill],
    classSkillCombos: [_skillCombo.default],
    skillPoints: _character.default.skillPoints
  })
}, {
  component: /*#__PURE__*/_react.default.createElement(_CharacterStatsWindow.default, {
    character: _character.default,
    characterClass: _character.default.characterClass,
    nation: _character.default.nation
  })
}, {
  component: /*#__PURE__*/_react.default.createElement(_MainBorderedWindow.default, {
    pages: [/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, null))]
  })
}];
var _default = mockedManagedWindows;
exports.default = _default;